module.exports = __webpack_public_path__ + "img/macchina.3a56df44.svg";